import * as SmartyStreetsSDK from "smartystreets-javascript-sdk";
import * as sdkUtils from "smartystreets-javascript-sdk-utils";

const SmartyStreetsCore = SmartyStreetsSDK.core;
let sharedCredentials,
  autoCompleteClientBuilder,
  usStreetClientBuilder,
  autoCompleteClient,
  usStreetClient;

const SmartyStreetService = {
  initialize: ({ apiKey }) => {
    sharedCredentials = new SmartyStreetsCore.SharedCredentials(apiKey);
    autoCompleteClientBuilder = new SmartyStreetsCore.ClientBuilder(sharedCredentials);
    usStreetClientBuilder = new SmartyStreetsCore.ClientBuilder(sharedCredentials);

    autoCompleteClient = autoCompleteClientBuilder.buildUsAutocompleteProClient();
    usStreetClient = usStreetClientBuilder.buildUsStreetApiClient();
  },
  queryAutocompleteForSuggestions: (query = "") => {
    const lookup = new SmartyStreetsSDK.usAutocompletePro.Lookup(query);
    return autoCompleteClient.send(lookup).then((response) => response.result);
  },
  validate: (address) => {
    // Only applicable for US addresses.
    const { address1, address2, city, stateName, zipcode } = address;
    const addressLookup = new SmartyStreetsSDK.usStreet.Lookup();
    addressLookup.street = address1;
    addressLookup.street2 = address2;
    addressLookup.city = city;
    addressLookup.state = stateName;
    addressLookup.zipCode = zipcode;
    addressLookup.candidates = 1;
    addressLookup.match = "invalid";
    return usStreetClient.send(addressLookup).then((response) => {
      const responseLookup = response.lookups[0];
      const isValid = sdkUtils.isValid(responseLookup);
      let validAddress = {};
      if (isValid) {
        const {
          deliveryLine1,
          deliveryLine2 = "",
          components = {},
        } = responseLookup.result[0] || {};
        const { cityName, state, zipCode } = components;
        validAddress = {
          address1: deliveryLine1,
          address2: deliveryLine2,
          city: cityName,
          stateName: state,
          zipcode: zipCode,
          formattedAddress: deliveryLine1,
        };
      }
      return { validAddress, isValid, response };
    });
  },
};

export default SmartyStreetService;
